import React, { useEffect, useMemo, useRef, useContext, useState } from "react";
import {
  Accordion,
  Card,
  Row,
  Col,
  Button,
  AccordionContext,
  useAccordionToggle,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Alert,
} from "react-bootstrap";
import moment from "moment";
import ModalDommus from "../../../../components/Modal";
import ModalEmail from "./ModalEmail";
import Swal from "sweetalert2";
import caAPI from "../../../../services/caAPI";
import "./style.scss";
import { Icon } from "@iconify/react";
import mailSendLine from "@iconify/icons-ri/mail-send-line";
import InfiniteScroll from "react-infinite-scroll-component";
import { WebSocketContext } from "../../../../contexts/WebSocketContext";
import { Templates } from "./templates";
import { trackPromise } from "react-promise-tracker";
import { faArrowAltCircleLeft, faDownload, faEnvelope, faEnvelopeOpen, faFileAlt, faLayerGroup, faLink, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DOMPurify from 'dompurify';
import { DommusThumbnail } from "../../../../components/DommusThumbnail";
import { DocumentViewer } from "react-documents";
import { TagDinamicaContext } from "../../../../contexts/TagDinamicaContext.js";
import { FormAtribuirTagsDinamicas } from "../../../../components/FormAtribuirTagsDinamicas/index.js";
import { DommusModalFullScreen } from "../../../../components/DommusModalFullScreen";

export function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isCurrentEventKey = currentEventKey === eventKey;
  return (
    <div
      style={{
        backgroundColor: isCurrentEventKey ? "#265d9c" : "rgba(0,0,0,.03)",
        color: isCurrentEventKey ? "white" : "black",
        padding: ".75rem 1.25rem",
        marginbottom: "0",
        borderbottom: "1px solid rgba(0,0,0,.125)",
      }}
      onClick={decoratedOnClick}
    >
      {children}
    </div>
  );
}

export default function EmailComponent({ atendimento, AtualizarListaEmails, desabilitarFooterEmail=false, mensagemSelecionada=null }) {
  const [listaMensagens, setListaMensagens] = useState([]);
  const [openModalEmail, setOpenModalEmail] = useState(false);
  const messageContainerRef = useRef();
  const [atendimentoAtivo, setAtendimentoAtivo] = useState(atendimento);
  const [hasMore, setHasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [assinatura, setAssinatura] = useState("");
  const [iniciado, setIniciado] = useState(false);
  const [modalTemplateAberto, setModalTemplateAberto] = useState(false);
  const [anexoSelecionadoVisualizacao, setAnexoSelecionadoVisualizacao] = useState(null);
  const [anexoCarregado, setAnexoCarregado] = useState(false);
  const [erroCarregamentoAnexo, setErroCarregamentoAnexo] = useState(false);
  const [mensagemInicialFormatar, setMensagemInicialFormatar] = useState({});
  const [openModalTagDinamica, setOpenModalTagDinamica] = useState(false);
  const {checarPossuiTagsDinamicas} = useContext(TagDinamicaContext)

  const handleDownloadAttachment = (attachment) => {
    const abrirArquivo = (url) => {
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = url;
      a.click();
    }
    if(attachment.url) {
      abrirArquivo(attachment.url)
    } else {
      trackPromise(caAPI.atendimento.email.getAnexo(attachment.file_name)).then((res) => abrirArquivo(res.data.url));
    }
  };

  useEffect(() => {
    if(!desabilitarFooterEmail){
      caAPI.atendimento.email
        .getAssinatura()
        .then((res) => {
          setAssinatura(
            res.data.assinatura
              ? JSON.parse(res.data.assinatura)
              : res.data.assinatura
          );
        })
        .catch((err) => {
          Swal.fire({
            titleText: "Erro",
            text: "Houve um problema ao buscar assinatura",
            icon: "error",
          });
          return;
    });
      setIniciado(!!atendimento.conteudos?.length)
      setAtendimentoAtivo(atendimento);
    }
  }, [atendimento, desabilitarFooterEmail]);

  useEffect(() => {
    handleProcessarMensagens(atendimentoAtivo.conteudos);
    setHasMore(atendimentoAtivo.hasMore);
  }, [atendimentoAtivo]);

  const handleProcessarMensagens = async (mensagens) =>{
    if (!mensagens) {
      setListaMensagens([]);
      return;
    }

    // Ordena por data
    const ordenadas = [...mensagens].sort((a, b) => new Date(b.criado_em) - new Date(a.criado_em));

    // Processa cada mensagem
    const processadas = await Promise.all(ordenadas.map(async (msg) => {
      let detalhes = JSON.parse(msg?.detalhes || '{}')?.data ?? {};
      let conteudo = msg?.conteudo?.replace(/\r\n|\r|\n/g, "<br/>");
      const arquivosNoCorpoSemColchetes = conteudo?.match(/\[[^\]]+\]/g)?.map(nome => nome.slice(1, -1)) || [];
      let textoModificado = conteudo;

      if (Array.isArray(arquivosNoCorpoSemColchetes)) {
        for (const arquivo of arquivosNoCorpoSemColchetes) {
          const arquivoEncontrado = detalhes?.attachments && detalhes?.attachments?.find(anexo => (anexo.original_name == arquivo || anexo.original_name == 'noname'));
          let url = arquivoEncontrado?.url ?? arquivo;

          // Verifica se é privada
          if (url.includes("arquivos.dommus")) {
            try {
              const response = await caAPI.arquivoAtendimento.downloadArquivoPrivado(url);
              // Cria URL blob para exibir a imagem
              const blobUrl = URL.createObjectURL(response.data);
              url = blobUrl;
            } catch (e) {
              // fallback: mantém url original
            }
          }

          const tagImg = `<img class="img-fluid pr-3" src="${url}" alt="${arquivo}">`;
          textoModificado = DOMPurify.sanitize(textoModificado?.replace(`[${arquivo}]`, tagImg), {
                ALLOWED_URI_REGEXP: /^(?:(?:https?|data|blob):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
              });
        }
      }
      const attachments = detalhes?.attachments || [];

      return { ...msg, attachments, detalhes, textoModificado };
    }));

    setListaMensagens(processadas);
  }

  const { channel } = useContext(WebSocketContext);
  useEffect(() => {
    channel.unbind('email.' + atendimentoAtivo.id);
    channel.bind("email." + atendimentoAtivo.id, function (data) {
      const newMessage = JSON.parse(data.mensagem);
      setListaMensagens((messages) => [...messages, newMessage]);
    });
  }, [channel, atendimentoAtivo]);

  const handleLoadMoreMessages = () => {
    const messages = [...listaMensagens];

    caAPI.atendimento
      .getMessages(atendimento.id, Number(currentPage) + 1)
      .then((res) => {
        messages.push(res.data);
        setCurrentPage(res.data.currentPage);
        setListaMensagens([...listaMensagens, ...res.data.conteudos]);
        setHasMore(res.data.hasMore);
      })
      .catch((err) => {
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao buscar mais mensagens",
          icon: "error",
        });
        return;
      });
  };

  const handlePreviewFile = (url, extensao) => {
    let typeViewer = "";

    switch(extensao){
       case 'png':
       case 'jpg':
       case 'jpeg':
       case 'svg':
       case 'pdf':
        typeViewer = 'url';
        extensao = "";
        break;
       case 'docx':
       case 'doc':
       case 'xlsx':
       case 'xlsm': 
        typeViewer = 'office';
        break;
       default:
        typeViewer = 'google';
        break;      
    }

    caAPI.arquivoAtendimento.downloadArquivoPrivado(url)
      .then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        const data = {
          url: blobUrl,
          typeViewer: typeViewer,
          extension: extensao
        }
        setAnexoSelecionadoVisualizacao(data);
      })
      .catch((err) => {
        // Se falhar o download privado, tenta usar a URL original
        const data = {
          url: url,
          typeViewer: typeViewer,
          extension: extensao
        }
        setAnexoSelecionadoVisualizacao(data);
      });
  }

  const itemMonitoramento = (monitoramento)=>{
    let dadosStatus = {
      lido: []
    };
    monitoramento.forEach((monitoramento)=>{
        switch(monitoramento.evento){
            case "processed":
                dadosStatus.enviado = monitoramento?.data_hora_evento;
                break;
            case "delivered":
                dadosStatus.entregue = monitoramento?.data_hora_evento;
                break;
            case "open":
                dadosStatus.lido.push(monitoramento?.data_hora_evento);
                break;
            case "click":
                dadosStatus.click_link = monitoramento?.data_hora_evento;
                break;
            default:
                break;
        }
    })
    return statusEmail(dadosStatus);
  }

  const statusEmail = (dadosStatus) => {
      return (
          <div className="section-status-disparo">
              <OverlayTrigger
                  key="badgeEnviado"
                  placement="top"
                  overlay={<Tooltip id={`tooltip-enviado`}>{dadosStatus?.enviado ? `Enviado em: ${moment(dadosStatus.enviado).format('DD/MM/YYYY HH:mm')}` : "Não enviado"}</Tooltip>}
              >
                  <span className={`badge-status-disparo ${dadosStatus?.enviado ? "enviado" : ""}`}>
                      <FontAwesomeIcon icon={faPaperPlane} />
                  </span>
              </OverlayTrigger>
              <OverlayTrigger
                  key="badgeEntregue"
                  placement="top"
                  overlay={
                      <Tooltip id={`tooltip-entregue`}>{dadosStatus?.entregue ? `Entregue em: ${moment(dadosStatus.entregue).format('DD/MM/YYYY HH:mm')}` : "Não entregue"}</Tooltip>
                  }
              >
                  <span className={`badge-status-disparo ${dadosStatus?.entregue ? "entregue" : ""}`}>
                      <FontAwesomeIcon icon={faEnvelope} />
                  </span>
              </OverlayTrigger>
              <OverlayTrigger
                  key="badgeLido"
                  placement="top"
                  overlay={<Tooltip id={`tooltip-Lido`}>{
                      dadosStatus?.lido?.length ? `Lido em: ${dadosStatus?.lido.map((data) => `\u25CF ${moment(data).format('DD/MM/YYYY HH:mm')}`)}` : "Não lido"}</Tooltip>}
              >
                  <span className={`badge-status-disparo ${dadosStatus?.lido.length ? "lido" : ""}`}>
                      <FontAwesomeIcon icon={faEnvelopeOpen} />
                      {dadosStatus?.lido?.length > 0 && 
                          <span className="qts-lido">{dadosStatus?.lido?.length}</span>
                      }
                  </span>
              </OverlayTrigger>
              {/* <OverlayTrigger
                  key="badgeAnexo"
                  placement="top"
                  overlay={
                      <Tooltip id={`tooltip-anexo`}>{dadosStatus.download_anexo ? `Download Anexo em: ${moment(dadosStatus.download_anexo).format('DD/MM/YYYY HH:mm')}` : "Não baixado"}</Tooltip>
                  }
              >
                  <span className={`badge-status-disparo ${dadosStatus.download_anexo ? "anexo" : ""}`}>
                      <FontAwesomeIcon icon={faDownload} />
                  </span>
              </OverlayTrigger> */}
              <OverlayTrigger
                  key="badgeLink"
                  placement="top"
                  overlay={
                      <Tooltip id={`tooltip-Link`}>{dadosStatus?.click_link ? `Clicado link em: ${moment(dadosStatus.click_link).format('DD/MM/YYYY HH:mm')}` : "Não clicado"}</Tooltip>
                  }
              >
                  <span className={`badge-status-disparo ${dadosStatus?.click_link ? "link" : ""}`}>
                      <FontAwesomeIcon icon={faLink} />
                  </span>
              </OverlayTrigger>
          </div>
      );
  };
  
  const mensagens = useMemo(() => {
    if (listaMensagens) {
      return listaMensagens.map((msg) => {
        return (
          <div className="email" key={msg.id} id={`mensagem-email-${msg.id}`}>
            <div className="header email-header">
              <Card>
                <Accordion>
                  <div className="accordion_iten">
                    <ContextAwareToggle
                      as={Card.Header}
                      cardName={msg?.id}
                      title={msg?.assunto}
                      eventKey={msg?.id}
                    >
                      <Row>
                        <Col>
                          <div className="dadosAssunto">
                            {msg?.direcao === "enviado" ? (
                              <Icon
                                className="iconeEnviadoRecebido"
                                icon={mailSendLine}
                              />
                            ) : (
                              <Icon
                                className="iconeEnviadoRecebido"
                                icon={mailSendLine}
                                hFlip={true}
                              />
                            )}
                            {msg?.assunto}
                          </div>
                        </Col>
                        <Col sm={4}>
                            <div className="data">
                              {!!msg?.monitoramento?.length &&
                                <div className="monitoramento-component-email">
                                  {itemMonitoramento(msg.monitoramento)}
                                </div>
                              }
                              {moment(msg.criado_em).format("DD/MM/YYYY HH:mm")}
                            </div>
                        </Col>
                      </Row>
                    </ContextAwareToggle>
                  </div>
                  <Accordion.Collapse eventKey={msg.id}>
                    <div className="dadosEnvio">
                      {msg.direcao === "enviado" ? (
                        <div className="dadosPara">Para: {msg?.to ?? "---"} </div>
                      ) : (
                        <div className="dadosDe">De: {msg?.from ?? "---"}</div>
                      )}
                      {msg?.cc ? (
                        <div className="dadosCopiaCortesia">
                          CC:{" "}
                          <span className="emailCopiaCortesia">
                            {" "}
                            {msg.cc}{" "}
                          </span>{" "}
                        </div>
                      ) : (
                        <></>
                      )}
                      {msg?.bcc ? (
                        <div className="dadosCopiaCortesiaOculta">
                          CCO:{" "}
                          <span className="emailCopiaCortesiaOculta">
                            {msg.bcc}{" "}
                          </span>{" "}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Accordion.Collapse>
                </Accordion>
              </Card>
            </div>
            <div className="body" style={{ overflowY: "hidden", overflowX: "auto"}}>
              {(msg?.textoModificado && <div dangerouslySetInnerHTML={{ __html: msg?.textoModificado }}/>) || <Alert className="mr-3" variant="warning">Nenhum conteúdo a ser exibido.</Alert>}
            </div>
            {msg?.attachments && (
                <div className=" mail-attachments-section">
                  {msg.attachments.map(function (attachment, index) {
                    return (
                      <OverlayTrigger
                        key={"file"+index}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-`+index}>
                            {attachment?.original_name || attachment?.file_name || ""}
                          </Tooltip>
                        }
                      >
                        <div key={index} className="thumb-anexo">
                          <DommusThumbnail arquivo={attachment} url={attachment?.url} extensao={attachment?.extension} handlePreviewFile={handlePreviewFile}/>
                        </div>
                      </OverlayTrigger>
                    );
                  })}
                </div>
              )}
          </div>
        );
      });
    }
  }, [listaMensagens]);

  useEffect(()=>{
    if(mensagemSelecionada){
      const elemento = document.getElementById(`mensagem-email-${mensagemSelecionada?.id}`);
      elemento?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
      setTimeout(()=>{
        elemento?.animate(
          [
            { boxShadow: '0 0 0 rgba(0,0,0,0)' },
            { boxShadow: '0 0 25px rgba(247,148,29,0.5)' },
          ],
          {
            duration: 800,
            easing: 'ease-in',
            fill: 'forwards'
          }
        );
      },100)
    }
  },[mensagens])

  useEffect(() => {
    const div = document.getElementById('scrollableDiv')
    if(div) {
      div.scrollTo({ top: div.scrollHeight, behavior: 'auto' })
    }
    setCurrentPage(1)
  }, [atendimentoAtivo.id])

  function recebeMensagemInicial(mensagemInicial) {
    if(checarPossuiTagsDinamicas(mensagemInicial.mensagem)){
      setMensagemInicialFormatar(mensagemInicial);
      setOpenModalTagDinamica(true);
    }else{
      enviarMensagemTemplate(mensagemInicial);
    }
  }

  function enviarMensagemTemplate(mensagemInicial) {
    const dadosEmail = { 
      id_atendimento: atendimentoAtivo.id, 
      body: mensagemInicial.mensagem, 
      template: true, 
      id_template:mensagemInicial.id_template,
      subject: mensagemInicial?.subject ?? ""
    }
    trackPromise(caAPI.atendimento.email.enviar(dadosEmail))
      .then(res => {
        const novaMensagem = res.data
        setListaMensagens((messages) => [novaMensagem, ...messages]);
        setIniciado(true);
        setModalTemplateAberto(false)
      }).catch(err => {
        console.log(err)
        console.log(err.response)
        if(err.response?.status === 422) {
          Swal.fire('Ooops...', err.response?.data?.message, 'warning')

          return
        }
        Swal.fire({
          titleText: "Erro",
          text: "Ocorreu um problema ao iniciar o atendimento.",
          icon: 'error'
        });
      })
  }

  return (
    <>
      <div className="email-container" id="scrollableDiv">
        {(!iniciado && !desabilitarFooterEmail && <Templates enviarMensagemTemplate={recebeMensagemInicial}/>) || <></>}
        <InfiniteScroll
          className="email-container"
          style={{ display: "flex", flexDirection: "column-reverse" }}
          dataLength={mensagens?.length}
          next={handleLoadMoreMessages}
          hasMore={hasMore}
          inverse={true}
          loader={<Spinner animation="border" style={{ color: "#265d9c" }} />}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Fim das Mensagens</b>
            </p>
          }
          refreshFunction={() => { }}
          pullDownToRefresh
          pullDownToRefreshThreshold={50}
          scrollableTarget="scrollableDiv"
        >
          {mensagens}
        </InfiniteScroll>
      </div>
      <div ref={messageContainerRef}></div>
      {!desabilitarFooterEmail &&
        <div className="footer email-footer">
          <Row>
            <Col className="px-0">
              <Button className="btnEnviarEmail px-1" onClick={() => setOpenModalEmail(true)}>
                <Icon icon={mailSendLine} fontSize={20} style={{ position: 'relative', top: '-1' }}/> Enviar Email
              </Button>
            </Col>
            {(iniciado && (
              <Col className="px-0">
                <Button variant="info" className="btnEnviarTemplate px-1" onClick={() => setModalTemplateAberto(true)}>
                  <FontAwesomeIcon icon={faLayerGroup}/> Enviar Template
                </Button>
              </Col>
            )) || <></>}
          </Row>
        </div>
      }
      <DommusModalFullScreen titulo="Enviar E-mail" open={openModalEmail} close={() => setOpenModalEmail(false)}>
        <ModalEmail
          assinatura={assinatura}
          AtualizarListaEmails={AtualizarListaEmails}
          setOpenModalEmail={setOpenModalEmail}
          atendimento={atendimento}
          assunto={listaMensagens[0]?.detalhes?.assunto}
        />
      </DommusModalFullScreen>
      <ModalDommus
        titulo="Enviar Email Template"
        open={modalTemplateAberto}
        close={() => setModalTemplateAberto(false)}
      >
        <div className="templates-scrolaveis px-3">
          <Row className="px-3">
            <Col className="p-3 rounded border" style={{ backgroundColor: '#F2F3F8' }}>
              <Templates enviarMensagemTemplate={recebeMensagemInicial}/>
            </Col>
          </Row>
          <Row>
            <Col className="p-3 text-right">
              <Button variant="secondary" onClick={() => setModalTemplateAberto(false)}>
                <FontAwesomeIcon icon={faArrowAltCircleLeft}/> Voltar
              </Button>
            </Col>
          </Row>
        </div>
      </ModalDommus>
      <ModalDommus
        titulo={
          <div className="header-visualizar-arquivo">
            <span>Visualizar arquivo</span> 
            <OverlayTrigger
              key={"file"}
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-download`}>
                  Baixar anexo
                </Tooltip>
              }
            >
              <FontAwesomeIcon 
                role="button" 
                icon={faDownload} 
                className="btn-download-file" 
                onClick={()=>{
                  handleDownloadAttachment(anexoSelecionadoVisualizacao)
                }}/>
            </OverlayTrigger>
          </div>
        }
        open={!!anexoSelecionadoVisualizacao}
        close={() => {
          setAnexoCarregado(false);
          setAnexoSelecionadoVisualizacao(null)
        }}
      >
        <div className="mail-modal-anexos">
          {['zip'].includes(anexoSelecionadoVisualizacao?.extension) ? 
            <Alert className="text-center" style={{cursor: 'pointer'}} variant="info" onClick={()=>{handleDownloadAttachment(anexoSelecionadoVisualizacao)}}>Não é possível carregar arquivos!. <b>Clique aqui para fazer o download</b></Alert>
          :
            <div className="documento-viewer-container">
              <DocumentViewer
                queryParams="hl=Nl"
                url={anexoSelecionadoVisualizacao?.url ?? ""}
                viewer={anexoSelecionadoVisualizacao?.typeViewer}
                viewerUrl={anexoSelecionadoVisualizacao?.extension}
              />
              {/* {!anexoCarregado &&  <DommusLoading/>} */}
            </div>
          }
        </div>
      </ModalDommus>
      
      <ModalDommus
        open={openModalTagDinamica}
        close={() => {
          setOpenModalTagDinamica(false);
        }}
        size="md"
        titulo="Tags Dinâmicas"
      >
        <FormAtribuirTagsDinamicas mensagemInicialFormatar={mensagemInicialFormatar} enviarMensagemTemplate={enviarMensagemTemplate} closeModal={()=>{setOpenModalTagDinamica(false); setModalTemplateAberto(false)}}/>
      </ModalDommus>
    </>
  );
}
